import React, { useState, useEffect, useRef } from "react";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import Loader from "../../../Components/UiComponents/Loader";
import { getOpportunity } from "../../../Services/opportunityService";
import _ from 'lodash';
import { Accordion, AccordionTab } from 'primereact/accordion';
import RadioElement from "../../../Components/UiComponents/RadioElement";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../Components/Videos/PlaylistVideos";
import { Dialog } from "primereact/dialog";

const Project = (props) => {
    const [loading, setLoading] = useState(false);
    const [opportunityData, setOpportunityData] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [newModule, setNewModule] = useState({});
    const [showVideo, setShowVideo] = useState(false);
    const toastRef = useRef()
    const navigate = useNavigate()

    const enduser = localStorage.getItem("enduser");
    if (enduser) {
        var tmpData = JSON.parse(enduser);
        if (tmpData === null) {
            navigate("/login")
            localStorage.clear()
        }
    }

    useEffect(() => {
        getOpportunityDetails()
    }, [])

    useEffect(() => {
        if (props.fieldData.frameworkSectionsProject) {
            let obj1 = _.find(props.fieldData.frameworkSectionsProject, { section_name: "Overview of Client" })?.display_name;
            let obj2 = _.find(props.fieldData.frameworkSectionsProject, { section_name: "Our Bid Team" })?.display_name;
            let obj3 = _.find(props.fieldData.frameworkSectionsProject, { section_name: "Contract" })?.display_name;

            let combined = { obj1, obj2, obj3 };
            setNewModule(combined)
        }
    }, [props.fieldData.frameworkSectionsProject])

    const getOpportunityDetails = async () => {
        try {
            setLoading(true)
            var opportunity = await getOpportunity(props.frameworkId, tmpData.customer)
            if (opportunity && opportunity.data) {
                setOpportunityData(opportunity.data)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const OpportunityDisplay = ({ opportunityData }) => {
        const handleLeftClick = () => {
            setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : opportunityData.length - 1));
        };

        const handleRightClick = () => {
            setCurrentIndex((prevIndex) => (prevIndex < opportunityData.length - 1 ? prevIndex + 1 : 0));
        };

        return (
            <div className="form-group row align-items-center mb-0 mt-20">
                <div className="col-md-7 pl-0 pt-17">
                    <p className="sub-label-text">
                        {opportunityData[currentIndex]?.opportunity_name ? opportunityData[currentIndex]?.opportunity_name : opportunityData[currentIndex]?.opportunity_alias}
                    </p>
                </div>
                <div className="col pr-0 d-flex justify-end">
                    <ButtonElement className="edit-option-button" type="button" icon="pi pi-chevron-left" onClick={handleLeftClick} />
                    <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-chevron-right" onClick={handleRightClick} />
                </div>
            </div>
        );
    };

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div className='new-field'>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div>
                <div className="form-group row align-items-center mb-0">
                    <div className="col-md-4 pl-0">
                        <p className="label-text">
                            {_.find(props.fieldData.frameworkSectionsProject, { section_name: "List of Framework Projects" })?.display_name}
                        </p>                    </div>
                    <div className="col-md-8 text-right">
                        <ButtonElement className="upload-button mb-2" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
                    </div>
                </div>


                {
                    _.find(props.fieldData.frameworkProjectTable, { table_name: "Projects" })?.status &&
                    <div className="box-border">
                        <div className="form-group row align-items-center mb-0">
                            <div className="col-md-6 pl-0">
                                <p className="label-text mb-0">
                                    {_.find(props.fieldData.frameworkProjectTable, { table_name: "Projects" })?.display_name}
                                </p>
                            </div>
                        </div>
                        <div>
                            {opportunityData.map((opportunity, index) => (
                                <li key={index} className="mar-t-8">
                                    <a className="form-label-text text-left mr-20 pointer" onClick={(e) => setCurrentIndex(index)}>{(opportunity.opportunity_name) != '' ? opportunity.opportunity_name : opportunity.opportunity_alias}</a>
                                </li>
                            ))}
                        </div>
                    </div>
                }
            </div>
            {
                opportunityData?.length > 0 && <OpportunityDisplay opportunityData={opportunityData} currentIndex={setCurrentIndex} />
            }
            {
                opportunityData.length > 0 && Object.entries(newModule).map(([key, value]) => (
                    <div key={key} className='mt-10'>
                        <Accordion activeIndex={0}>
                            {
                                <AccordionTab header={value} disabled>
                                    {
                                        key == 'obj1' &&
                                        <div className="new-field">
                                            {
                                                _.find(props.fieldData.projectFieldsSummary, { field_name: 'Project ID' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.projectFieldsSummary, { field_name: 'Project ID' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0'>
                                                        <label className="form-label text-left">{opportunityData[currentIndex]?.opportunity_seq}</label>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                _.find(props.fieldData.projectFieldsNew, { field_name: 'Project Name' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.projectFieldsNew, { field_name: 'Project Name' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0'>
                                                        <label className="form-label text-left">{opportunityData[currentIndex]?.opportunity_name}</label>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                _.find(props.fieldData.projectFieldsSummary, { field_name: 'Project Description' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.projectFieldsSummary, { field_name: 'Project Description' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0'>
                                                        <label className="form-label text-left">{opportunityData[currentIndex]?.summary.opportunity_description}</label>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                _.find(props.fieldData.projectFieldsNew, { field_name: 'Type' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.projectFieldsNew, { field_name: 'Type' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0'>
                                                        <label className="form-label text-left">{opportunityData[currentIndex]?.opportunity_type}</label>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                _.find(props.fieldData.projectFieldsSummary, { field_name: 'Work Type' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.projectFieldsSummary, { field_name: 'Work Type' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0'>
                                                        <label className="form-label text-left">{opportunityData[currentIndex]?.summary.work_type}</label>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                _.find(props.fieldData.projectFieldsSummary, { field_name: 'Form of Contract' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.projectFieldsSummary, { field_name: 'Form of Contract' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0'>
                                                        <label className="form-label text-left">{opportunityData[currentIndex]?.summary.form_of_contract}</label>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                _.find(props.fieldData.projectFieldsSummary, { field_name: 'Procurement Route' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.projectFieldsSummary, { field_name: 'Procurement Route' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0'>
                                                        <label className="form-label text-left">{opportunityData[currentIndex]?.summary.procurement_route}</label>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                _.find(props.fieldData.clientFieldsNew, { field_name: 'Client Name' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.clientFieldsNew, { field_name: 'Client Name' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0'>
                                                        <label className="form-label text-left">{opportunityData[currentIndex]?.client_name}</label>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                _.find(props.fieldData.commanFields, { field_name: 'Sector' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.commanFields, { field_name: 'Sector' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0'>
                                                        <label className="form-label text-left">{opportunityData[currentIndex]?.sector}</label>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                    {
                                        key == 'obj2' &&
                                        <div className="new-field d-flex">
                                            <div className='col-md-6 pl-0'>
                                                {
                                                    _.find(props.fieldData.projectFieldsNew, { field_name: 'Bid Leader' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.fieldData.projectFieldsNew, { field_name: 'Bid Leader' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{opportunityData[currentIndex]?.bid_Leader}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.fieldData.commanFields, { field_name: 'Business Unit' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.fieldData.commanFields, { field_name: 'Business Unit' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{opportunityData[currentIndex]?.business_unit}</label>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            {
                                                _.find(props.fieldData.frameworkProjectTable, { table_name: 'Bid Team List' })?.status === true &&
                                                <div className='col-md-6 pl-0'>
                                                    <div className="box-border">
                                                        <div className="form-group row align-items-center mb-0">
                                                            <div className="col-md-6 pl-0">
                                                                <p className="label-text">
                                                                    {_.find(props.fieldData.frameworkProjectTable, { table_name: 'Bid Team List' })?.display_name}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className='w-50'>
                                                            {
                                                                opportunityData[currentIndex]?.ie_bid_team.internal_bid_team.map((teamMember, memberIndex) => (
                                                                    <li>
                                                                        <label className="form-label text-left" key={memberIndex}>{teamMember.team_member}</label>
                                                                    </li>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                    {
                                        key == 'obj3' &&
                                        <div className="new-field">
                                            {
                                                _.find(props.fieldData.projectFieldsSummary, { field_name: 'Award Date' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-4 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.projectFieldsSummary, { field_name: 'Award Date' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0 d-flex'>
                                                        <RadioElement
                                                            id="award_date"
                                                            options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                            value={opportunityData[currentIndex]?.summary?.award_date?.radio}
                                                            className="radio-group-class"
                                                            disabled
                                                        />
                                                        <label className="form-label text-left ml-20">{opportunityData[currentIndex]?.summary?.award_date?.text}</label>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                _.find(props.fieldData.projectFieldsSummary, { field_name: 'Project Start Date' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-4 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.projectFieldsSummary, { field_name: 'Project Start Date' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0 d-flex'>
                                                        <RadioElement
                                                            id="contract_start_date_summary"
                                                            options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                            value={opportunityData[currentIndex]?.summary?.contract_start_date_summary?.radio}
                                                            className="radio-group-class"
                                                            disabled
                                                        />
                                                        <label className="form-label text-left ml-20">{opportunityData[currentIndex]?.summary?.contract_start_date_summary?.text}</label>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                _.find(props.fieldData.projectFieldsSummary, { field_name: 'Project End Date' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-4 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.projectFieldsSummary, { field_name: 'Project End Date' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0 d-flex'>
                                                        <RadioElement
                                                            id="contract_end_date_summary"
                                                            options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                            value={opportunityData[currentIndex]?.summary?.contract_end_date_summary?.radio}
                                                            className="radio-group-class"
                                                            disabled
                                                        />
                                                        <label className="form-label text-left ml-20">{opportunityData[currentIndex]?.summary?.contract_end_date_summary?.text}</label>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                _.find(props.fieldData.projectFieldsSummary, { field_name: 'Total Contract Value' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-4 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.projectFieldsSummary, { field_name: 'Total Contract Value' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0'>
                                                        <label className="form-label text-left ml-20">{props.currency + ' ' + opportunityData[currentIndex]?.total_contract_value?.text}</label>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                _.find(props.fieldData.projectFieldsSummary, { field_name: 'Margin Expected' })?.field_status === true &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-4 pl-0">
                                                        <label className="form-label text-left">{_.find(props.fieldData.projectFieldsSummary, { field_name: 'Margin Expected' })?.display_name}:</label>
                                                    </div>
                                                    <div className='col pr-0 d-flex'>
                                                        <RadioElement
                                                            id="margin_expected"
                                                            options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                            value={opportunityData[currentIndex]?.summary?.margin_expected?.radio}
                                                            className="radio-group-class"
                                                            disabled
                                                        />
                                                        <label className="form-label text-left ml-20">{opportunityData[currentIndex]?.summary?.margin_expected?.text}</label>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                </AccordionTab>
                            }
                        </Accordion>
                    </div>
                ))
            }
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_PROGRAMMES_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="programme_project" />
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default Project